import React, { useCallback } from 'react';
import { Modal } from './Modal';
import { Button } from './Button';
import { useTranslation } from 'react-i18next';
import { blurbyBase } from '../config';

export function LeaveProjectModal({ show, onHide }) {
  const { t } = useTranslation();
  const onContinue = useCallback(() => {
    window.location.href = blurbyBase;
  }, []);
  return (
    <Modal
      show={show}
      title="Leaving your project"
      onHide={onHide}
      footer={
        <>
          <Button onClick={onHide} variant="tertiary" width="140px">
            Cancel
          </Button>
          <Button onClick={onContinue} variant="primary" width="182px">
            Continue
          </Button>
        </>
      }
    >
      {t('MODAL.Leaving_Web_Editor_Body')}
    </Modal>
  );
}
